import { DomainConfig } from "@hypexone/uicore";
import { getEnvVariable } from "./brandConfig";

export const domain = window.location.hostname;
export const BRAND_NAME = getEnvVariable(domain, 'BRAND_NAME');
export const BRAND_DOMAIN = getEnvVariable(domain, 'BRAND_DOMAIN');
export const SKIN_NAME = 'Laser';
// Note: It is the main site url. Ex - apnigame.com, etc.
export const BRAND_DOMAIN_SKIN_URL = 'domain_skin_url';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'kalbuzz.lol';
export const IS_NEW_SCORECARD_ENABLED = getEnvVariable(domain, 'IS_NEW_SCORECARD_ENABLED');

const DEFAULT_SCORECARD_DOMAIN = 'play.winadda.co.in';

export const SCORECARD_DOMAIN =
  getEnvVariable(domain, 'SCORECARD_DOMAIN') || DEFAULT_SCORECARD_DOMAIN;
export const FB_PIXEL_IDS: string[] = getEnvVariable(domain, 'FB_PIXEL_IDS') ?? [];
export const GTM_IDS: string[] = getEnvVariable(domain, 'GTM_IDS') ?? [];
export const GTAG_IDS: string[] = getEnvVariable(domain, 'GTAG_IDS') ?? [];
export const META_TITLE: string = getEnvVariable(domain, 'META_TITLE') ?? '';
export const META_DESCRIPTION: string = getEnvVariable(domain, 'META_DESCRIPTION') ?? '';

/** Sign Up goes to WhatsApp when HA has signup off but signin on. */
export const isWhatsappSignup = (domainConfig: DomainConfig) =>
  !domainConfig?.signup && !!domainConfig?.signin;
